import React, { useRef, useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import ToggleButton from "react-bootstrap/ToggleButton";

const DiaperSizeCalculatorLanding = (props) => {
  let componentData = props.componentData; // layout service data
  let diaperSizeData = props.diaperSizeData; // parent prop to take inputs
  const { t } = props; // for dictionary phrases

  // diaper size data states
  const [brandId, setBrandId] = useState();
  const [babyHeight, setBabyHeight] = useState();
  const [babyHeightUnit, setBabyHeightUnit] = useState();
  const [babyWeight, setBabyWeight] = useState();
  const [babyWeightUnit, setBabyWeightUnit] = useState();
  const [eventId, setEventId] = useState();
  const [eventType, setEventType] = useState();
  const [tripDuration, setTripDuration] = useState();
  const [showInputs, setShowInputs] = useState(false);
  const [showTripDuration, setShowTripDuration] = useState(false);
  //height unit
  const [heightUnit, setHeightUnit] = useState("CM");

  // event dropdown
  const [showEventItems, setShowEventItems] = useState(false);
  const [defaultSearchType, setDefaultSearchType] = useState("Select Event");

  // brand dropdown
  const [showBrandItems, setShowBrandItems] = useState(false);
  const [defaultBrandSearchType, setDefaultBrandSearchType] = useState(
    componentData.ProductLinePlaceholderTest.value
  );

  // height weight switch state
  const [isHeightUnitToggled, setIsHeightUnitToggled] = useState(false);
  const [isWeightUnitToggled, setIsWeightUnitToggled] = useState(false);

  // height weight switch state
  const [isHeightUnitChecked, setIsHeightUnitChecked] = useState(
    componentData.HeightUnits[0].fields.name.value
  );
  const [isWeightUnitChecked, setIsWeightUnitChecked] = useState(
    componentData.weightUnits[0].fields.name.value
  );

  // height validation state
  const [babyHeightCMValidation, setBabyHeightCMValidation] = useState(false);
  const [babyHeightFeetValidation, setBabyHeightFeetValidation] =
    useState(false);

  // weight validation state
  const [babyWeightKGSValidation, setBabyWeightKGSValidation] = useState(false);
  const [babyWeightLBSValidation, setBabyWeightLBSValidation] = useState(false);

  // trip validation state
  const [tripDurationValidation, setTripDurationValidation] = useState(false);

  // height radio object
  const heightRadios = [
    {
      name: componentData.HeightUnits[0].fields.name.value,
      id: componentData.HeightUnits[0].id,
    },
    {
      name: componentData.HeightUnits[1].fields.name.value,
      id: componentData.HeightUnits[1].id,
    },
  ];

  // height radio object
  const weightRadios = [
    {
      name: componentData.weightUnits[0].fields.name.value,
      id: componentData.weightUnits[0].id,
    },
    {
      name: componentData.weightUnits[1].fields.name.value,
      id: componentData.weightUnits[1].id,
    },
  ];

  // handle toggle switch for baby height/weight
  const toggleSwitch = (field, value) => {
    if (field === "babyHeightUnit") {
      setBabyHeightCMValidation(false);
      setBabyHeightFeetValidation(false);
      setBabyHeight("");
      // document.getElementById("txtBabyHeight").focus();
      document.getElementById("txtBabyHeight").value = "";
      if (value === componentData.HeightUnits[1].id) {
        setBabyHeightUnit(componentData.HeightUnits[1].id); // Feet
        setIsHeightUnitChecked(componentData.HeightUnits[1].fields.name.value);
        setHeightUnit("Feet"); // setting unit to Feets
      } else {
        setBabyHeightUnit(componentData.HeightUnits[0].id); // CM
        setIsHeightUnitChecked(componentData.HeightUnits[0].fields.name.value);
        setHeightUnit("CM"); // setting unit to CM
      }
      setIsHeightUnitToggled(!isHeightUnitToggled);
    } else if (field === "babyWeightUnit") {
      setBabyWeightKGSValidation(false);
      setBabyWeightLBSValidation(false);
      setBabyWeight("");
      // document.getElementById("txtBabyWeight").focus();
      document.getElementById("txtBabyWeight").value = "";
      if (value === componentData.weightUnits[1].id) {
        setBabyWeightUnit(componentData.weightUnits[1].id); // lbs
        setIsWeightUnitChecked(componentData.weightUnits[1].fields.name.value);
      } else {
        setBabyWeightUnit(componentData.weightUnits[0].id); // kgs
        setIsWeightUnitChecked(componentData.weightUnits[0].fields.name.value);
      }
      setIsWeightUnitToggled(!isWeightUnitToggled);
    }
  };

  // set brand details
  const setBrandDetails = (item) => {
    setDefaultBrandSearchType(item.fields["Brand Name"].value);
    setShowBrandItems(false);

    setBrandId(item.id);
  };

  // set event details
  const setEventDetails = (item) => {
    setDefaultSearchType(item.fields["Event Description"].value);
    setShowEventItems(false);

    setEventId(item.id);
    setEventType(item.fields["Event Name"].value);

    if (item.fields["Event Name"].value === "Diaper For Trip") {
      setShowTripDuration(true);
      document.getElementById("btn-calculate").disabled = true;
    } else {
      setShowTripDuration(false);
      setTripDuration(0);
      document.getElementById("btn-calculate").disabled = false;
    }
  };

  // This function check text box having only numbers or decimal
  const checkNumberOnly = (field, e) => {
    var selectedText = window.getSelection && window.getSelection().toString();
    if (e.target.value.length == 4 && selectedText.length == 4) {
      return true;
    }
    if (field === "tripValue") {
      // enabling select all and input new value
      if (e.target.value.length == 2 && selectedText.length == 2) {
        return true;
      }
      // for trip duration validation
      if (e.target.value.length == 2) {
        e.preventDefault();
      }
      // Not allowing entering "."
      if (e.key === ".") {
        e.preventDefault();
      }
    }
    if (e.target.value.length == 4) {
      e.preventDefault();
    }
    if (
      e.keyCode != 46 &&
      e.which != 8 &&
      e.keyCode > 31 &&
      (e.keyCode < 48 || e.keyCode > 57)
    ) {
      return false;
    }

    // Not allowing entering "e"
    if (e.key === "e") {
      e.preventDefault();
    }

    // Not allowing entering "-"
    if (e.key === "-") {
      e.preventDefault();
    }
    // allowing entering "."
    if (e.key === ".") {
      return false;
    }
  };

  // Height format check
  const checkNumberOnlyHeight = (field, e) => {
    var key = e.keyCode ? e.keyCode : e.which;
    var selectedText =
      (document.selection && document.selection.createRange().text) ||
      (window.getSelection && window.getSelection().toString());
    if (e.target.value.length >= 0 && selectedText.length > 1) {
      // allowing selected values in textbox edit
      e.target.value = (e.key + "'").toString();
      setBabyHeight(e.target.value);
      e.preventDefault();
    }
    if (e.target.value.length == 4) {
      e.preventDefault();
    }
    if (
      e.target.value.indexOf("'") > -1 &&
      e.target.value.split("'")[1].length > 2
    ) {
      e.preventDefault();
    } else {
      if (e.target.value.length === 0 && isHeightUnitToggled) {
        e.target.value = (e.key + "'").toString();
        setBabyHeight(e.target.value);
        e.preventDefault();
      } else if (e.target.value.length === 3 && isHeightUnitToggled) {
        var height = e.target.value;
        if (height[2] == 1 && key !== 48 && key !== 49) {
          e.preventDefault();
        } else if (height[2] > 1) {
          e.preventDefault();
        }
      }

      var key = e.keyCode ? e.keyCode : e.which;
      let inputElement = e.target.value;
      // enabling select all and input new value
      if (e.target.value.length == 4 && selectedText.length == 3) {
        return true;
      }
      // Not allowing entering "'" more than one
      if (key === 39 && inputElement.indexOf(e.key) !== -1) e.preventDefault();
      // Allowing "'" in input box
      if (key === 39) return true;
      // Handling below scenario for restricting alphabets
      if (key >= 97 && key <= 122) e.preventDefault();
      // For Preventing entering special Character
      if (key > 31 && (key < 48 || key > 57)) e.preventDefault();
      // Handling special case for character 'e'
      if (key === 101) e.preventDefault();
      else if (
        !(
          [8, 9, 13, 27, 46, 110, 190].indexOf(key) !== -1 ||
          (key == 65 && (e.ctrlKey || e.metaKey)) ||
          (key >= 35 && key <= 40) ||
          (key >= 48 && key <= 57 && !(e.shiftKey || e.altKey)) ||
          (key >= 96 && key <= 105)
        )
      )
        e.preventDefault();
    }
  };

  // Height Validator
  const checkHeightValidation = () => {
    if (babyHeightUnit === componentData.HeightUnits[0].id) {
      // check for CM
      if (
        Number(babyHeight) <
          Number(componentData.HeightUnits[0].fields["Min Value"].value) ||
        Number(babyHeight) >
          Number(componentData.HeightUnits[0].fields["Max Value"].value)
      ) {
        setBabyHeightCMValidation(true);
        document.getElementById("btn-calculate").disabled = true;
      } else {
        setBabyHeightCMValidation(false);
      }
    } else if (babyHeightUnit === componentData.HeightUnits[1].id) {
      // check for feet'inches
      let babyHeightInFeet = babyHeight.replace(/'/g, "."); // converting height feet'inches to decimal values (eg. 3'0 === 3.0)
      if (
        Number(babyHeightInFeet) <
          Number(componentData.HeightUnits[1].fields["Min Value"].value) ||
        Number(babyHeightInFeet) >
          Number(componentData.HeightUnits[1].fields["Max Value"].value)
      ) {
        setBabyHeightFeetValidation(true);
        document.getElementById("btn-calculate").disabled = true;
      } else {
        setBabyHeightFeetValidation(false);
      }
    }
  };

  // Weight Validator
  const checkWeightValidation = () => {
    if (babyWeightUnit === componentData.weightUnits[0].id) {
      // check for KGS
      if (
        Number(babyWeight) <
          Number(componentData.weightUnits[0].fields["Min Value"].value) ||
        Number(babyWeight) >
          Number(componentData.weightUnits[0].fields["Max Value"].value)
      ) {
        setBabyWeightKGSValidation(true);
        document.getElementById("btn-calculate").disabled = true;
      } else {
        setBabyWeightKGSValidation(false);
      }
    } else if (babyWeightUnit === componentData.weightUnits[1].id) {
      // check for LBS
      if (
        Number(babyWeight) <
          Number(componentData.weightUnits[1].fields["Min Value"].value) ||
        Number(babyWeight) >
          Number(componentData.weightUnits[1].fields["Max Value"].value)
      ) {
        setBabyWeightLBSValidation(true);
        document.getElementById("btn-calculate").disabled = true;
      } else {
        setBabyWeightLBSValidation(false);
      }
    }
  };

  // Trip Validator
  const checkTripDurationValidation = () => {
    if (Number(tripDuration) < Number(1) || Number(tripDuration) > Number(60)) {
      setTripDurationValidation(true);
      document.getElementById("btn-calculate").disabled = true;
    } else {
      setTripDurationValidation(false);
    }
  };

  // Evevnt Drop down
  const evevntDropDown = () => {
    showEventItems ? setShowEventItems(false) : setShowEventItems(true);
  };

  // Brand Drop down
  const brandDropDown = () => {
    showBrandItems ? setShowBrandItems(false) : setShowBrandItems(true);
  };

  const wrapperRefBrand = useRef(null);
  const wrapperRefEvent = useRef(null);
  useOutsideAlerterBrand(wrapperRefBrand); // handle outside click to close brand Drop down
  useOutsideAlerterEvent(wrapperRefEvent); // handle outside click to close event Drop down

  // handle outside click to close brand Drop down
  function useOutsideAlerterBrand(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowBrandItems(false);
        }
      }

      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  // handle outside click to close event Drop down
  function useOutsideAlerterEvent(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowEventItems(false);
        }
      }

      // Bind the event listener
      document.addEventListener("click", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref]);
  }

  // check form validation and
  const validateFormFields = () => {
    if (eventType !== "Diaper For Trip") {
      if (
        babyHeightUnit &&
        babyWeightUnit &&
        brandId &&
        babyHeight &&
        babyWeight &&
        eventId
      ) {
        document.getElementById("btn-calculate").disabled = false;
      } else {
        document.getElementById("btn-calculate").disabled = true;
      }
    } else if (eventType === "Diaper For Trip") {
      if (
        babyHeightUnit &&
        babyWeightUnit &&
        brandId &&
        babyHeight &&
        babyWeight &&
        eventId &&
        tripDuration
      ) {
        document.getElementById("btn-calculate").disabled = false;
      } else {
        document.getElementById("btn-calculate").disabled = true;
      }
    }
  };

  // to setting default baby height and weight units
  useEffect(() => {
    setBabyHeightUnit(componentData.HeightUnits[0].id);
    setBabyWeightUnit(componentData.weightUnits[0].id);
  }, []);

  // to enable height weight unit input fields
  useEffect(() => {
    if (brandId && eventId) {
      setShowInputs(true);
    } else {
      setShowInputs(false);
    }
  }, [brandId, eventId]);

  // to sending data to parent component
  useEffect(() => {
    validateFormFields();
    diaperSizeData(
      babyHeightUnit,
      babyWeightUnit,
      brandId,
      babyHeight,
      babyWeight,
      eventId,
      eventType,
      tripDuration,
      heightUnit
    );
  }, [
    babyHeightUnit,
    babyWeightUnit,
    brandId,
    babyHeight,
    babyWeight,
    eventId,
    eventType,
    tripDuration,
    heightUnit,
  ]);

  // to check tripDuration, babyHeight, babyWeight validation
  useEffect(() => {
    if (tripDuration) {
      checkTripDurationValidation();
    }
    checkHeightValidation();
    checkWeightValidation();
  }, [tripDuration, babyHeight, babyWeight]);

  return (
    <>
      {componentData != null && (
        <>
          <div className="row mx-md-3">
            <div className={isMobile ? "col-12" : "col-md-8 col-sm-12"}>
              <div className="form-group">
                <label htmlFor="selectEvent">
                  {componentData.EventLabel.value}
                </label>
                <div className="custom-select-dropdown">
                  <div className="select-box--box">
                    <div className="select-box--container">
                      <div
                        className={"select-box--selected-item"}
                        onClick={evevntDropDown}
                        ref={wrapperRefEvent}
                      >
                        <div
                          className={
                            !showEventItems
                              ? "select-box-selected-item-text-div"
                              : "select-box-selected-item-text-div-close"
                          }
                        >
                          <span
                            style={{ textTransform: "capitalize" }}
                            className={
                              defaultSearchType === "Select Event"
                                ? "brand-select-box-selected-item-text-faded select-box-selected-item-text-faded"
                                : "select-box-selected-item-text"
                            }
                          >
                            {defaultSearchType.toLowerCase()}
                          </span>
                        </div>
                        <div
                          className="select-box--arrow"
                          name="select-box--name"
                        >
                          <span
                            name="drop-down-arrow"
                            className={`${
                              showEventItems
                                ? "select-box--arrow-up fa fa-angle-up"
                                : "select-box--arrow-down fa fa-angle-down"
                            }`}
                          ></span>
                        </div>
                      </div>
                      <div
                        style={{ display: showEventItems ? "block" : "none" }}
                        className="select-box--items"
                      >
                        {componentData.Events.map((item, index) => {
                          return (
                            <div
                              className={
                                defaultSearchType ===
                                item.fields["Event Description"].value
                                  ? "select-div selected"
                                  : "select-div"
                              }
                              key={index}
                              onClick={() => setEventDetails(item)}
                            >
                              <p className="nameListItem">
                                {" "}
                                {item.fields["Event Description"].value}{" "}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={isMobile ? "col-12" : "col-md-4 col-sm-12"}>
              <div className="form-group">
                <label htmlFor="selectProduct">
                  {componentData.ProductLineLabel.value}
                </label>
                <div className="brand-select">
                  <div className="custom-select-dropdown">
                    <div className="select-box--box">
                      <div className="select-box--container">
                        <div
                          className={"select-box--selected-item"}
                          onClick={brandDropDown}
                          ref={wrapperRefBrand}
                        >
                          <div
                            className={
                              !showBrandItems
                                ? "select-box-selected-item-text-div"
                                : "select-box-selected-item-text-div-close"
                            }
                          >
                            <span
                              style={{ textTransform: "capitalize" }}
                              className={
                                defaultBrandSearchType ===
                                componentData.ProductLinePlaceholderTest.value
                                  ? "select-box-selected-item-text-faded"
                                  : "select-box-selected-item-text"
                              }
                            >
                              {defaultBrandSearchType.toLowerCase()}
                            </span>
                          </div>
                          <div
                            className="select-box--arrow"
                            name="select-box--name"
                          >
                            <span
                              name="drop-down-arrow"
                              className={`${
                                showBrandItems
                                  ? "select-box--arrow-up fa fa-angle-up"
                                  : "select-box--arrow-down fa fa-angle-down"
                              }`}
                            ></span>
                          </div>
                        </div>
                        <div
                          style={{ display: showBrandItems ? "block" : "none" }}
                          className="select-box--items"
                        >
                          {componentData["Diaper Brands"].map((item, index) => {
                            return (
                              <div
                                className={
                                  defaultBrandSearchType ===
                                  item.fields["Brand Name"].value
                                    ? "select-div selected"
                                    : "select-div"
                                }
                                key={index}
                                onClick={() => setBrandDetails(item)}
                              >
                                <p className="nameListItem">
                                  {" "}
                                  {item.fields["Brand Name"].value}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showInputs && (
            <>
              <hr className="border-top" />
              <div className="row justify-content-center">
                <div
                  className={isMobile ? "col-12" : "col-md-2 col-sm-12 col-12"}
                >
                  <div className="form-group">
                    <label htmlFor="txtBabyHeight">
                      {componentData.BabyHeightLabel.value}
                      <a
                        className="ttlink"
                        alt={componentData.BabyHeightLabelPlaceholderText.value}
                      >
                        <i className="fa fa-question-circle"></i>
                        <span>
                          {componentData.BabyHeightLabelPlaceholderText.value}
                        </span>
                      </a>
                    </label>
                    <input
                      type={isHeightUnitToggled ? "text" : "number"}
                      step=".1"
                      min={
                        !isHeightUnitToggled
                          ? componentData.HeightUnits[0].fields["Min Value"]
                              .value
                          : componentData.HeightUnits[1].fields["Min Value"]
                              .value
                      }
                      max={
                        !isHeightUnitToggled
                          ? componentData.HeightUnits[0].fields["Max Value"]
                              .value
                          : componentData.HeightUnits[1].fields["Max Value"]
                              .value
                      }
                      className="form-control"
                      id="txtBabyHeight"
                      placeholder={
                        componentData.BabyHeightLabelPlaceholderText.value
                      }
                      value={babyHeight || ""}
                      onChange={(e) => setBabyHeight(e.target.value)}
                      onKeyPress={(e) =>
                        checkNumberOnlyHeight("heightValue", e)
                      }
                    />
                    <div
                      className={
                        babyHeightCMValidation
                          ? "d-block invalid-feedback"
                          : "d-none"
                      }
                    >
                      Baby height should be in between of{" "}
                      {componentData.HeightUnits[0].fields["Min Value"].value}{" "}
                      to{" "}
                      {componentData.HeightUnits[0].fields["Max Value"].value}{" "}
                      {componentData.HeightUnits[0].fields.name.value}
                    </div>
                    <div
                      className={
                        babyHeightFeetValidation
                          ? "d-block invalid-feedback"
                          : "d-none"
                      }
                    >
                      Baby height should be in between of{" "}
                      {componentData.HeightUnits[1].fields["Min Value"].value}{" "}
                      to{" "}
                      {componentData.HeightUnits[1].fields["Max Value"].value}{" "}
                      {componentData.HeightUnits[1].fields.name.value}
                    </div>
                  </div>
                </div>
                <div
                  className={isMobile ? "col-12" : "col-md-2 col-sm-12 col-12"}
                >
                  <div className="form-group">
                    <label htmlFor="txtBabyHeightUnit">{t("DiaperSizeCalculator_UnitsToUse")}</label>
                    <div className="switch-box-wrapper">
                      <ButtonGroup toggle size="sm">
                        {heightRadios.map((radio, id) => (
                          <ToggleButton
                            key={id}
                            id={`radio-${id}`}
                            type="radio"
                            variant="secondary"
                            name="radio"
                            value={radio.name}
                            checked={isHeightUnitChecked === radio.name}
                            onChange={(e) =>
                              toggleSwitch("babyHeightUnit", radio.id)
                            }
                          >
                            {radio.name}
                          </ToggleButton>
                        ))}
                      </ButtonGroup>
                    </div>
                  </div>
                </div>
                <div
                  className={isMobile ? "col-12" : "col-md-2 col-sm-12 col-12"}
                >
                  <div className="form-group">
                    <label htmlFor="txtBabyWeight">
                      {componentData.BabyWeightLabel.value}
                      <a
                        className="ttlink"
                        alt={componentData.BabyWeightLabelPlaceholderText.value}
                      >
                        <i className="fa fa-question-circle"></i>
                        <span>
                          {componentData.BabyWeightLabelPlaceholderText.value}
                        </span>
                      </a>
                    </label>
                    <input
                      type="number"
                      step=".1"
                      min={
                        !isWeightUnitToggled
                          ? componentData.weightUnits[0].fields["Min Value"]
                              .value
                          : componentData.weightUnits[1].fields["Min Value"]
                              .value
                      }
                      max={
                        !isWeightUnitToggled
                          ? componentData.weightUnits[0].fields["Max Value"]
                              .value
                          : componentData.weightUnits[1].fields["Max Value"]
                              .value
                      }
                      className="form-control"
                      id="txtBabyWeight"
                      placeholder={
                        componentData.BabyWeightLabelPlaceholderText.value
                      }
                      value={babyWeight || ""}
                      onChange={(e) => setBabyWeight(e.target.value)}
                      onKeyPress={(e) => checkNumberOnly("weightValue", e)}
                    />
                    <div
                      className={
                        babyWeightKGSValidation
                          ? "d-block invalid-feedback"
                          : "d-none"
                      }
                    >
                      Baby weight should be in between of{" "}
                      {componentData.weightUnits[0].fields["Min Value"].value}{" "}
                      to{" "}
                      {componentData.weightUnits[0].fields["Max Value"].value}{" "}
                      {componentData.weightUnits[0].fields.name.value}
                    </div>
                    <div
                      className={
                        babyWeightLBSValidation
                          ? "d-block invalid-feedback"
                          : "d-none"
                      }
                    >
                      Baby weight should be in between of{" "}
                      {componentData.weightUnits[1].fields["Min Value"].value}{" "}
                      to{" "}
                      {componentData.weightUnits[1].fields["Max Value"].value}{" "}
                      {componentData.weightUnits[1].fields.name.value}
                    </div>
                  </div>
                </div>
                <div
                  className={isMobile ? "col-12" : "col-md-2 col-sm-12 col-12"}
                >
                  <div className="form-group">
                    <label htmlFor="txtBabyWeightUnit">{t("DiaperSizeCalculator_UnitsToUse")}</label>
                    <div className="switch-box-wrapper">
                      <ButtonGroup toggle size="sm">
                        {weightRadios.map((radio, id) => (
                          <ToggleButton
                            key={id}
                            id={`radio-${id}`}
                            type="radio"
                            variant="secondary"
                            name="radio"
                            value={radio.name}
                            checked={isWeightUnitChecked === radio.name}
                            onChange={(e) =>
                              toggleSwitch("babyWeightUnit", radio.id)
                            }
                          >
                            {radio.name}
                          </ToggleButton>
                        ))}
                      </ButtonGroup>
                    </div>
                  </div>
                </div>
                {showTripDuration && (
                  <div
                    className={
                      isMobile ? "col-12" : "col-md-2 col-sm-12 col-12"
                    }
                  >
                    <div className="form-group">
                      <label htmlFor="txtTripDuration">Trip Duration</label>
                      <input
                        type="number"
                        step="1"
                        min="1"
                        max="60"
                        value={tripDuration || ""}
                        className="form-control"
                        id="txtTripDuration"
                        placeholder="Enter duration"
                        onChange={(e) => setTripDuration(e.target.value)}
                        onKeyPress={(e) => checkNumberOnly("tripValue", e)}
                      />
                      <div
                        className={
                          tripDurationValidation
                            ? "d-block invalid-feedback"
                            : "d-none"
                        }
                      >
                        {t("DiaperSizeCalculator_NoOfDaysValidationMsg")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default withTranslation()(DiaperSizeCalculatorLanding);
